import { ReleasesScreen } from './ReleasesScreen';

export const releasesRoute = { path: 'releases', element: <ReleasesScreen /> };
